import { Field, FieldArray, Form, Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from "./NewChecklist.module.css";
import { AssessmentSettings } from "./AssessmentSettings/AssessmentSettings";
import { KpiSettings } from "./KpiSettings/KpiSettings";
import { FinalScore } from "./FinalScore/FinalScore";
import * as Yup from "yup";
import DropdownChecklist from "../../components/controls/DropdownChecklist/DropdownChecklist";
import Select from "../../components/controls/Select/Select";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
// import { LegalEntityServiceApi } from "../../service/api/LegalEntityServiceApi";
import { ControlFunctionServiceApi } from "../../service/api/ControlFunctionServiceApi";
import { ChecklistServicesApi } from "../../service/api/ChecklistServicesApi";
import { TemplateQuantitativeDriverServiceApi } from "../../service";
import {useHistory} from "react-router-dom";
import {Block} from "../../hoc/Block";
import {InputField} from "../../components/controls/InputField/InputField";
import GenericModal from "../../UI/GenericModal";
import { isSuperuserValue } from "../../access/access";

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());

let queryStringChecklistId = params["checklistId"];

const initialValues = {
  id: 0,
  'kpiweight-1': 0,
  'kpiweight-2': 0,
  'kpiweight-3': 0,
  'kpiweight-4': 0,
  'kpiweight-5': 0,
  'kpiweight-6': 0,
  groupLevel: "",
  subsidiary: "",
  company: "",
  legalEntityRegion: "",
  fiscalYear: "",
  checklistPeriod: {},
  controlFunction: "",
  operationalScopes: [],
  supervisedEntity: true,
  operativeCompany: true,
  foreign: true,
  qualitativeOnly: true,
  qualitativeWeight: 0,
  quantitativeWeight: 0,
  checklistTemplateQuantitativeDrivers: [],
  coverage: 0,
  accuracy: 1,
}

const EditEvaluatedChecklist = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/checklist-monitor");
    }
    let mounted = true;

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringChecklistId = params["checklistId"];

    const checklistServicesApi = new ChecklistServicesApi();
    checklistServicesApi.getChecklistById(queryStringChecklistId, (error, data) => {
      if (mounted) {
        if (!error) {
          if (data.checklistState.name !== "Under Review" && data.checklistState.name !== "Confirmed") {
            console.log("Checklist with id ", data.id, " cannot be opened in this page due to the checklist status");
            history.push("/checklist-monitor");
          }
          setIsLoading(true);
          console.log("My checklist: ", data);
        
          initialValues.id = data.id;
          initialValues.groupLevel = data.legalEntityParentCompany;
          initialValues.subsidiary = data.legalEntitySubsidiary;
          initialValues.company = data.legalEntityCompany;
          initialValues.fiscalYear = data.fiscalYear;
          initialValues.checklistPeriod = data.checklistPeriod;
          initialValues.legalEntityRegion = data.legalEntityRegion;
          initialValues.controlFunction = data.controlFunction;
          initialValues.operationalScopes = data.operationalScopes.map(item => {
            return {
              name: item.name,
              id: item.id
            }
          });
          initialValues.supervisedEntity = data.supervisedEntity;
          initialValues.operativeCompany = data.operativeCompany;
          initialValues.foreign = data.foreign;
          initialValues.qualitativeOnly = data.qualitativeOnly;
          initialValues.qualitativeWeight = data.qualitativeWeight;
          initialValues.quantitativeWeight = data.quantitativeWeight;
          initialValues.checklistTemplateQuantitativeDrivers = data.checklistTemplateQuantitativeDrivers.sort(
            (a,b) => a.templateQuantitativeDriver.position > b.templateQuantitativeDriver.position ? 1 : -1
          );
          initialValues.accuracy = data.accuracy;
          initialValues.coverage = data.coverage;
          
          initialValues.checklistTemplateQuantitativeDrivers.forEach((item) => {
            initialValues["kpiweight-"+item.templateQuantitativeDriver.id] = item.weight;
          });
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
        setIsLoading(false);
      }
    });
    
    return () => { 
      mounted = false;
    }
  }, []);
  
  const validationSchema = Yup.object().shape({
    accuracy: Yup.number().typeError('Accuracy must be a number')
        .min(1, 'Accuracy min value is 1')
        .max(100, 'Accuracy max value is 100'),
    coverage: Yup.number()
        .min(0, 'Coverage min value is 0')
        .max(100, 'Coverage max value is 100'),
    qualitativeWeight: Yup.number()
        .min(0, 'Qualitative Module Weight min value is 0')
        .max(100, 'Qualitative Module Weight max value is 100'),
    quantitativeWeight: Yup.number()
        .min(0, 'Quantitative Module Weight min value is 0')
        .max(100, 'Quantitative Module Weight max value is 100'),
    "kpiweight-1": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-2": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-3": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-4": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-5": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100'),
    "kpiweight-6": Yup.number()
        .min(0, 'KPI Weight min value is 0')
        .max(100, 'KPI Weight max value is 100')
  });

  const submitFormHandler = (values) => {
      console.log("form values", values);
      const err = checkConstraints(values);
      if(!err.notValid) {
        modalDataHandler("Update checklist", "Save changes?", 'confirmation', () => updateChecklist(values));
      } else {
        modalDataHandler("", "Error in values", 'error', () => setModalShow(false));
      }
  }

  const checkConstraints = function(values, props) {
    console.log("check constraints", values);

    const errors = {};

    if(values.qualitativeOnly === "Yes") {
      if(values.coverage + values.qualitativeWeight !== 100) {
        errors.coverage = "Invalid Coverage";
      }
    } else {
      if(values.qualitativeOnly === false && values.quantitativeWeight === 0) {
        errors.kpiCoverage = "Invalid KPI Coverage, Quantitative Module Weight must be > 0";
      } else {
        if(values.checklistTemplateQuantitativeDrivers && values.checklistTemplateQuantitativeDrivers.length > 0) {
          let totalKPICoverage = 0;
          values.checklistTemplateQuantitativeDrivers.filter((item) => item.enabled === true).forEach((item) => {
            totalKPICoverage += values["kpiweight-"+item.templateQuantitativeDriver.id];
          });
          if(totalKPICoverage !== values.quantitativeWeight) {
            errors.kpiCoverage = "Invalid KPI Coverage";
          }
        }
      }

      if(values.coverage + values.qualitativeWeight + values.quantitativeWeight !== 100) {
        errors.coverage = "Invalid Coverage";
      }
    }

    return errors;

  }

  const updateChecklist = function(formValues) {
    console.log("update checklist");
    setIsLoadingButtons(true);

    //recover weight values from the form and populate the object for the api call
    if(formValues.checklistTemplateQuantitativeDrivers) {
      formValues.checklistTemplateQuantitativeDrivers.forEach((item, index) => {
        item.templateQuantitativeDriverId = item.templateQuantitativeDriver.id;
        if(formValues["kpiweight-"+item.templateQuantitativeDriver.id] != null) {
          item.weight = formValues["kpiweight-"+item.templateQuantitativeDriver.id];
        }
      });
    }

    const apiInput = {
      "id": formValues.id,
      "legalEntityParentCompanyId": formValues.groupLevel.id,
      "legalEntitySubsidiaryId": formValues.subsidiary.id,
      "legalEntityCompanyId": formValues.company.id,
      "legalEntityRegionId": formValues.legalEntityRegion.id,
      "checklistPeriodId": formValues.checklistPeriod.id,
      "controlFunctionId": formValues.controlFunction.id,
      "operationalScopeIds": formValues.operationalScopes.map((item) => item.id),
      "checklistTemplateQuantitativeDrivers": formValues.checklistTemplateQuantitativeDrivers,
      "fiscalYear": formValues.fiscalYear,
      "supervisedEntity": (formValues.supervisedEntity === "true"),
      "operativeCompany": (formValues.operativeCompany.toString() === "true"),
      "foreign": (formValues.foreign.toString() === "true"),
      "qualitativeOnly": formValues.qualitativeOnly,
      "qualitativeWeight": formValues.qualitativeWeight,
      "quantitativeWeight": formValues.quantitativeWeight,
      "coverage": formValues.coverage,
      "accuracy": formValues.accuracy
    }

    console.log("apiInput: ", apiInput);
    const checklistServicesApi = new ChecklistServicesApi();

    checklistServicesApi.updateChecklist(apiInput, apiInput.id, (error, data) => {
      if (!error) {
        console.log("responseData: ", data);
        modalDataHandler("", "Checklist updated!", 'notification', () => history.push("/checklist-monitor"));
        // history.push("/checklist-monitor")
      } else {
        modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, "Error! The checklist was not saved!", 'error', () => setModalShow(false));
      }
      setIsLoadingButtons(false);
    });
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
    setModalAction(action ? () => action : null);
  }

  return (
      <div>
        <GenericModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
        {isLoading && <div className="spinnerContainer">
          <div className="spinner-border text-primary " role="status">
            <span className="sr-only"></span>
          </div>
        </div>}

        {!isLoading && <div className={styles.form}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validate={checkConstraints}
        onSubmit={submitFormHandler}
        enableReinitialize
        validateOnChange={true}
        validateOnMount={true}
      >
        {({
            values,
            errors,
            touched,
            isValid,
            setFieldValue,
            validateForm
          }) => {
          return (
            <Form>
              <Row>
                <Col md={5} className="p-1">
                  <Col className="text-start">
                    <label className="fw-bold mb-2 ms-1">
                      Legal Entity (Group level)
                    </label>
                  </Col>
                  <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.groupLevel.name}</div>
                  </Col>
                </Col>
                <Col md={5} className="p-1">
                  <Col className="text-start">
                    <label className="fw-bold mb-2 ms-1">Region</label>
                  </Col>
                  <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.legalEntityRegion.name}</div>
                  </Col>
                </Col>
                <Col md={2} className="d-flex ps-1">
                  <img
                      src={nexiLogo}
                      className={`${styles.logo}`}
                      alt="nexi-group"
                  />
                </Col>
                <Col xs={5} className="p-1">
                  <Col className="text-start">
                    <label className="fw-bold mb-2 ms-1">
                      Legal Entity (Subsidiary)
                    </label>
                  </Col>
                  <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.subsidiary.name}</div>
                  </Col>
                </Col>
                <Col xs={5} className="p-1">
                  <Col className="text-start">
                    <label htmlFor="group-level" className="fw-bold mb-2 mb-1">
                      Fiscal Year
                    </label>
                  </Col>
                  <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.fiscalYear}</div>
                  </Col>
                </Col>
                <Col xs={5} className="p-1">
                  <Col className="text-start">
                    <label className="fw-bold mb-2 ms-1">
                      Legal Entity (Company)
                    </label>
                  </Col>
                  <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.company.name}</div>
                  </Col>
                </Col>
                <Col xs={{ span: 5 }} className="p-1">
                    <Col className="text-start">
                      <label className="fw-bold mb-2 ms-1">
                        Period
                      </label>
                    </Col>
                    <Col sm={12} className="p-0">
                    <div className="ms-1 nexiColor  fw-bold">{initialValues.checklistPeriod.name}</div>
                    </Col>
                  </Col>
              </Row>
              <div className="hr"></div>
              <Row className={styles.mh_px_100}>
                <Col>
                  <div className="fw-bold mb-2 mb-1">
                    Control Function:
                  </div>
                  <div>
                    {initialValues.controlFunction.name}
                  </div>
                </Col>
                <Col>
                  <div className="fw-bold mb-2 mb-1">
                    Operational Areas:
                  </div>
                  <ul>
                    {initialValues.operationalScopes.map((item, index) =>
                      <li className="nexiColor" key={index}>
                        {item.name}
                      </li>
                    )}
                  </ul>
                </Col>
              </Row>

              {!isLoading && (
                <Block className="mt-2">
                  <Row>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Supervised entity:</label>
                    </Col>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Operating legal entity:</label>
                    </Col>
                    <Col xs={3} className="text-start">
                      <label className="fst-italic">Other region:</label>
                    </Col>
                  </Row>
                  <Row>
                    {["supervisedEntity", "operativeCompany", "foreign"].map(el => {
                      return <Col xs={3} className="nexiColor fw-bold">
                        {initialValues[el]  ? "Yes" : "No"}
                      </Col>
                      // return <Col xs={3} className="px-1 nexiColor fw-bold">
                      //   {initialValues[el]  ? "Yes" : "No"}
                      // </Col>
                    })} 
                  </Row>
                </Block>
              )}

              <p className="text-start fw-bold mt-3 mb-0">
                Assessment Settings
              </p>
              <div className="hr"></div>
              <Block>
                <Row className="my-1">
                  <Col sm={5} className="text-start">
                    <label className="fst-italic">Qualitative Evaluation only?</label>
                  </Col>
                  <Col className="ps-1 d-flex justify-content-start">
                    {initialValues.qualitativeOnly  ? "Yes" : "No"}
                  </Col>
                </Row>
                <Row className="my-1">
                  <Col sm={5} className="text-start">
                    <label className="fst-italic" htmlFor="quality-weight">
                      Qualitative module weight (%):
                    </label>
                  </Col>
                  <Col className="ps-1 d-flex justify-content-start">
                    <InputField
                        type="number"
                        name="qualitativeWeight"
                        id="qualitativeWeight"
                        fieldtype="number"
                    />
                  </Col>
                </Row>
                {
                  initialValues.qualitativeOnly === false && <Row className="my-1">
                    <Col sm={5} className="text-start">
                      <label className="fst-italic" htmlFor="quantity-weight">
                        Quantitative module weight (%):
                      </label>
                    </Col>
                    <Col className="ps-1 d-flex justify-content-start">
                      <InputField
                          type="number"
                          name="quantitativeWeight"
                          id="quantitativeWeight"
                          fieldtype="number"
                      />
                    </Col>
                  </Row>
                }
              </Block>

              <p className="text-start fw-bold mt-3 mb-0">KPI Settings</p>
              <div className={` $"hr" mb-3`}></div>
              <Block>
                <Row>
                  {initialValues.checklistTemplateQuantitativeDrivers.map((item, index) =>
                      <Col xs={4} key={index}>
                        <div>
                          <label className="fw-bold">KPI {item.templateQuantitativeDriver.id}</label>
                        </div>
                        <label>{item.templateQuantitativeDriver.title}</label>
                        <div className="mt-2">
                          <label className="fst-italic">KPI {item.templateQuantitativeDriver.id} Weight (%)</label>
                          <InputField
                              className="ms-2"
                              type="number"
                              fieldtype="number"
                              name={"kpiweight-" + (item.templateQuantitativeDriver.id)}
                              id={"kpiweight-" + (item.templateQuantitativeDriver.id)}
                          />
                        </div>
                      </Col>
                  )}
                </Row>
              </Block>

              <p className="text-start fw-bold mt-3 mb-0">
                Final score (Data coverage and accuracy)
              </p>
              <div className="hr"></div>
              <Block className="p-1">
                <Row>
                  <Col xs={5} className="d-flex justify-content-between">
                    <label className="fst-italic">Coverage index weight (%):</label>
                    <InputField
                        type="number"
                        id="coverage"
                        name="coverage"
                        fieldtype="number"
                    />

                  </Col>
                  <Col xs={7} className="d-flex justify-content-around">
                    <label className="fst-italic">Accuracy index of data (%):</label>
                    <InputField
                        type="number"
                        id="accuracy"
                        name="accuracy"
                        fieldtype="number"
                    />
                  </Col>
                </Row>
              </Block>

              {!isLoadingButtons && <div className="w-100 d-flex justify-content-center">
                <SubmitButton type="submit" disabled={!isValid} className={`mt-3 mb-1`}>Update</SubmitButton>
                <ul className={styles.errorsList}>
                  {Object.values(errors).map((item, index) =>
                    <li key={index}>{item}</li>
                  )}
                </ul>
              </div>}
              {isLoadingButtons && <div className="spinnerContainer">
                <div className="spinner-border text-primary " role="status">
                  <span className="sr-only"></span>
                </div>
              </div>}
            </Form>
          );
        }}
      </Formik>
    </div>}
      </div>
  );
};

export default EditEvaluatedChecklist;
